const storageKey = (channelId: string) => `automation_first_time_banner_dismissed_${channelId}`;

/** Whether the user dismissed the automation guidance banner for this channel */
export function isFirstTimeBannerDismissed(channelId: string): boolean {
  try {
    return localStorage.getItem(storageKey(channelId)) === 'true';
  } catch {
    return false;
  }
}

export function dismissFirstTimeBanner(channelId: string): void {
  try {
    localStorage.setItem(storageKey(channelId), 'true');
  } catch {
    // ignore quota / private mode
  }
}

/** Clear dismiss flag when labels are configured — banner can show again if labels are cleared later */
export function clearFirstTimeBannerDismissed(channelId: string): void {
  try {
    localStorage.removeItem(storageKey(channelId));
  } catch {
    // ignore
  }
}
